import PlusProductSummary from './PlusProductSummary';

export default PlusProductSummary;
